import React, { useState, useEffect } from "react";
import { fetchAll } from "../utils/fetchResources";
import { useHistory, Prompt } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { onReadyCKE, CKEconfig } from "../config/CKE";
import SetFile from "../components/SetFile";
import {
  Typography,
  Switch,
  FormGroup,
  FormControl,
  InputLabel,
  Input,
  FormControlLabel,
  MenuItem,
  Select,
  Grid,
  Button,
  TextField,
  Hidden,
  Card,
  CardContent,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";

//console.log(Editor.builtinPlugins.map((plugin) => plugin.pluginName));

const useStyles = makeStyles((theme) => ({
  form: {
    width: "100%", // Fix IE 11 issue.
  },
  submit: {
    margin: theme.spacing(2, 0, 1),
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
}));

export default function EntriesAdd(props) {
  const classes = useStyles();
  const [newEntry, setNewEntry] = useState({
    relatedEntries: [],
    relatedPeople: [],
    published: false,
  });
  const [sites, setSites] = useState();
  const [selectedSite, setSelectedSite] = useState();
  const [existingEntries, setExistingEntries] = useState();
  const [existingPeople, setExistingPeople] = useState();
  const [themes, setThemes] = useState([]);
  const [regions, setRegions] = useState([]);
  const [units, setUnits] = useState([]);
  const [unsaved, setUnsaved] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  useEffect(() => {
    fetchAll("people", setExistingPeople, "name");
    fetchAll("entries", setExistingEntries, "title");
    fetchAll("themes", setThemes, "name");
    fetchAll("regions", setRegions, "name");
    fetchAll("units", setUnits, "name");
    fetchAll("sites", setSites, "name");
  }, []);

  const onChange = (e) => {
    setNewEntry({ ...newEntry, [e.target.name]: e.target.value });
    setUnsaved(true);
  };

  const onChangeSite = (e) => {
    setSelectedSite(e.target.value);
  };

  const onChangeCKE = (e, editor, fieldName) => {
    const data = editor.getData();
    setNewEntry({ ...newEntry, [fieldName]: data });
    setUnsaved(true);
  };

  const onChangePublished = (event) => {
    setNewEntry({ ...newEntry, [event.target.name]: event.target.checked });
    setUnsaved(true);
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (!selectedSite) {
      enqueueSnackbar("Please select a Site for this entry", {
        variant: "error",
      });
    }

    //Remove any keys with an empty str as the value
    for (const key of Object.keys(newEntry)) {
      if (newEntry[key] === "") {
        delete newEntry[key];
      }
    }

    fetch(`${process.env.REACT_APP_API_URL}/entries`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(newEntry),
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setUnsaved(false);
          enqueueSnackbar("Entry added successfully!", { variant: "success" });
          history.push(`/${process.env.REACT_APP_ADMIN_URL}/entries`);
        } else {
          console.log(data);
          const errorArray = data.error.split(",");
          errorArray.forEach((error) => {
            enqueueSnackbar(`${error}`, { variant: "error" });
          });
        }
      });
  };

  return (
    <>
      <Prompt
        when={unsaved}
        message="You have unsaved changes. Are you sure you want to leave?"
      />
      <Typography component="h1" variant="h4">
        Add an Entry
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={9}>
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            id="title"
            label="Entry's Title"
            name="title"
            size="small"
            autoFocus
            required
            onChange={onChange}
          />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl
                fullWidth
                className={classes.formControl}
                size="medium"
                margin="normal"
              >
                <InputLabel id="relatedPeopleLabel">Related People</InputLabel>
                <Select
                  inputProps={{ name: "relatedPeople" }}
                  labelId="relatedPeople"
                  id="relatedPeople"
                  multiple
                  value={newEntry.relatedPeople}
                  onChange={onChange}
                  input={<Input />}
                  renderValue={() => "View Selected"}
                >
                  {existingPeople &&
                    existingPeople.map((person) => {
                      const fullName = (person) => {
                        let name = "";
                        if (person.firstName) {
                          name += person.firstName;
                        }
                        if (person.middleName) {
                          name += " " + person.middleName;
                        }
                        if (person.lastName) {
                          name += " " + person.lastName;
                        }
                        if (person.suffix) {
                          name += " " + person.suffix;
                        }
                        if (person.title) {
                          name += ", " + person.title;
                        }
                        return name;
                      };
                      return (
                        <MenuItem key={person._id} value={person._id}>
                          {fullName(person)}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl
                fullWidth
                className={classes.formControl}
                size="medium"
                margin="normal"
              >
                <InputLabel id="relatedEntriesLabel">
                  Related Entries
                </InputLabel>
                <Select
                  inputProps={{ name: "relatedEntries" }}
                  labelId="relatedEntries"
                  id="relatedEntries"
                  multiple
                  value={newEntry.relatedEntries}
                  onChange={onChange}
                  renderValue={() => "View Selected"}
                >
                  {/*If the site is not yet selected, it doesn't filter any of the relatedEntries out*/}
                  {existingEntries &&
                    !selectedSite &&
                    existingEntries.map((entry) => (
                      <MenuItem key={entry._id} value={entry._id}>
                        {entry.title}
                      </MenuItem>
                    ))}
                  {/*If the site IS selected, it adds the filter before mapping*/}
                  {existingEntries &&
                    selectedSite &&
                    existingEntries
                      .filter((entry) => entry.unit.site._id === selectedSite)
                      .map((entry) => (
                        <MenuItem key={entry._id} value={entry._id}>
                          {entry.title}
                        </MenuItem>
                      ))}
									}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Typography style={{ marginTop: "1.5rem", fontWeight: "bold" }}>
            Description:
          </Typography>
          <CKEditor
            onReady={(editor) => {
              onReadyCKE(editor);
            }}
            editor={Editor}
            onChange={(e, editor) => onChangeCKE(e, editor, "description")}
            config={CKEconfig("Entry's short description...")}
          />
          <Typography style={{ marginTop: "1.5rem", fontWeight: "bold" }}>
            Historical Background:
          </Typography>
          <CKEditor
            onReady={(editor) => {
              onReadyCKE(editor);
            }}
            editor={Editor}
            onChange={(e, editor) => {
              onChangeCKE(e, editor, "historicalBackground");
            }}
            config={CKEconfig("Entry's historical background...")}
          />
          <Typography style={{ marginTop: "1.5rem", fontWeight: "bold" }}>
            Citation Text:
          </Typography>
          <CKEditor
            onReady={(editor) => {
              onReadyCKE(editor);
            }}
            editor={Editor}
            onChange={(e, editor) => {
              onChangeCKE(e, editor, "citationText");
            }}
            config={CKEconfig("Citation text...")}
          />
          <Typography style={{ marginTop: "1.5rem", fontWeight: "bold" }}>
            Repository:
          </Typography>
          <CKEditor
            onReady={(editor) => {
              onReadyCKE(editor);
            }}
            editor={Editor}
            onChange={(e, editor) => onChangeCKE(e, editor, "repository")}
            config={CKEconfig("Repository...")}
          />
          <Typography style={{ marginTop: "1.5rem", fontWeight: "bold" }}>
            Links:
          </Typography>
          <CKEditor
            onReady={(editor) => {
              onReadyCKE(editor);
            }}
            editor={Editor}
            onChange={(e, editor) => onChangeCKE(e, editor, "links")}
            config={CKEconfig("Links...")}
          />
          <Typography style={{ marginTop: "1.5rem", fontWeight: "bold" }}>
            For Educators:
          </Typography>
          <CKEditor
            onReady={(editor) => {
              onReadyCKE(editor);
            }}
            editor={Editor}
            onChange={(e, editor) => onChangeCKE(e, editor, "forEducators")}
            config={CKEconfig("For Educators...")}
          />
          <Typography style={{ marginTop: "1.5rem", fontWeight: "bold" }}>
            Suggested Reading:
          </Typography>
          <CKEditor
            onReady={(editor) => {
              onReadyCKE(editor);
            }}
            editor={Editor}
            onChange={(e, editor) => onChangeCKE(e, editor, "suggestedReading")}
            config={CKEconfig("Suggested Reading...")}
          />
          <Button
            type="submit"
            onClick={onSubmit}
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Save
          </Button>
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <Card>
            <CardContent>
              <Hidden smDown>
                <Button
                  type="submit"
                  onClick={onSubmit}
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  Save
                </Button>
              </Hidden>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Switch
                      color="primary"
                      checked={newEntry.published}
                      onChange={onChangePublished}
                      name="published"
                    />
                  }
                  label={
                    newEntry.published ? (
                      <Typography color="primary">Published</Typography>
                    ) : (
                      <Typography color="secondary">Draft</Typography>
                    )
                  }
                />
              </FormGroup>
              <SetFile
                fileTitle="Featured Image"
                resource={newEntry}
                setResource={setNewEntry}
                imageOnly={true}
                fileLabel="featuredImage"
                fileLabelFileName="featuredImageFile"
              />
              <SetFile
                fileTitle="High Res"
                resource={newEntry}
                setResource={setNewEntry}
                imageOnly={false}
                fileLabel="hires"
                fileLabelFileName="hiresFile"
              />
              <SetFile
                fileTitle="Transcription"
                resource={newEntry}
                setResource={setNewEntry}
                imageOnly={false}
                fileLabel="transcription"
                fileLabelFileName="transcriptionFile"
              />
              <FormControl
                fullWidth
                size="medium"
                required
                className={classes.formControl}
              >
                <InputLabel id="unit-label">Site</InputLabel>
                <Select
                  inputProps={{ name: "site" }}
                  value={selectedSite ?? ""}
                  onChange={onChangeSite}
                  label="site"
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {sites &&
                    sites.map((site, index) => {
                      return (
                        <MenuItem key={index} value={site._id}>
                          {site.name}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
              {selectedSite && (
                <>
                  <FormControl
                    fullWidth
                    size="medium"
                    className={classes.formControl}
                    required
                  >
                    <InputLabel id="unit-label">Unit</InputLabel>
                    <Select
                      inputProps={{ name: "unit" }}
                      value={newEntry.unit ?? ""}
                      onChange={onChange}
                      label="unit"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {units &&
                        units
                          .filter((unit) => unit.site._id === selectedSite)
                          .map((unit, index) => {
                            return (
                              <MenuItem key={index} value={unit._id}>
                                {unit.name}
                              </MenuItem>
                            );
                          })}
                    </Select>
                  </FormControl>
                  <FormControl
                    fullWidth
                    size="medium"
                    className={classes.formControl}
                  >
                    <InputLabel id="themes-input-label">Themes</InputLabel>
                    <Select
                      multiple
                      name="themes"
                      value={newEntry.themes ?? []}
                      onChange={onChange}
                      input={<Input id="themes" />}
                    >
                      {themes &&
                        themes
                          .filter((theme) => selectedSite === theme.site._id)
                          .map((theme) => (
                            <MenuItem key={theme.id} value={theme._id}>
                              {theme.name}
                            </MenuItem>
                          ))}
                    </Select>
                  </FormControl>
                  {
                    regions && regions.filter((region) => selectedSite === region.site._id).length > 0 &&
                  <>
                  <FormControl
                    fullWidth
                    size="medium"
                    className={classes.formControl}
                  >
                    <InputLabel id="regions-input-label">Regions</InputLabel>
                    <Select
                      multiple
                      name="regions"
                      value={newEntry.regions ?? []}
                      onChange={onChange}
                      input={<Input id="regions" />}
                    >
                      {regions &&
                        regions
                          .filter((region) => selectedSite === region.site._id)
                          .map((region) => (
                            <MenuItem key={region.id} value={region._id}>
                              {region.name}
                            </MenuItem>
                          ))}
                    </Select>
                  </FormControl>
                      </>
                  }
                </>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}
